import { useTheme } from "./ThemeProvider";

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const assetBase = process.env.PUBLIC_URL || "";

  return (
    <div className="theme-switch-wrapper position-relative">
      <label className="theme-switch" htmlFor="checkbox">
        {isDarkMode ? (
          <>
            <input type="checkbox" className="d-none" id="checkbox" />
            <span
              className="slider text-black header-right__button white-version"
              onClick={toggleTheme}
            >
              <img src={`${assetBase}/assets/images/icons/sun.svg`} alt="light mode" />
            </span>
          </>
        ) : (
          <>
            <span
              className="slider text-black header-right__button dark-version"
              onClick={toggleTheme}
            >
              <img src={`${assetBase}/assets/images/icons/moon.svg`} alt="dark mode" />
            </span>
          </>
        )}
      </label>
    </div>
  );
};

export default ThemeToggle;
